import { Avatar, Box, Typography } from "@mui/material";
import { BOX_SHADOW_BUTTON } from "../../../../utils/colors";

const PlatformSelector = ({
  platformOptions,
  selectedPlatforms,
  onTogglePlatform,
  onHandleKeyToggle,
}) => {
  const onHandleWheel = (e) => {
    const el = e.currentTarget;
    const canScrollX = el.scrollWidth > el.clientWidth;
    if (!canScrollX) return;

    if (e.deltaY !== 0) {
      el.scrollLeft += e.deltaY;
      e.preventDefault();
    }
  };

  const containerSx = {
    bgcolor: "#f5f5f5",
    borderRadius: 2,
    p: 0.8,
    gap: 0.5,
    display: { xs: "flex", sm: "grid" },
    gridTemplateColumns: { sm: `repeat(${platformOptions.length}, 1fr)` },
    flexWrap: { xs: "nowrap" },
    overflowX: { xs: "auto" },
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    overscrollBehaviorX: "contain",
    "&::-webkit-scrollbar": { display: "none" },
    scrollbarWidth: "none",
    px: { xs: 1, sm: 0.8 },
  };

  const itemSx = (isSelected, disabled) => {
    const isMutedOption = !disabled && !isSelected;
    return {
      height: 64,
      px: 1,
      borderRadius: 1.5,
      fontSize: 12,
      fontWeight: 500,
      transition: "all 0.2s",
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.5,
      opacity: disabled ? 0.45 : isMutedOption ? 0.72 : 1,
      border: isSelected
        ? "1px solid rgba(0, 0, 0, 0.2)"
        : "1px solid transparent",
      bgcolor: isSelected ? "background.paper" : "rgba(0, 0, 0, 0.02)",
      boxShadow: isSelected ? BOX_SHADOW_BUTTON : "none",

      "&:hover":
        !disabled && !isSelected
          ? { bgcolor: "rgba(0,0,0,0.06)", opacity: 0.85 }
          : {},
      flex: { xs: "0 0 auto", sm: "unset" },
      width: { xs: 92, sm: "auto" },
    };
  };

  return (
    <Box sx={containerSx} onWheel={onHandleWheel}>
      {platformOptions.map((platform) => {
        const disabled = !!platform.disabled;
        const isSelected = selectedPlatforms.includes(platform.value);
        const showFullColor = isSelected && !disabled;

        return (
          <Box
            key={platform.value}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-pressed={isSelected}
            aria-disabled={disabled}
            onKeyDown={(event) =>
              onHandleKeyToggle(event, platform.value, disabled)
            }
            onClick={() => !disabled && onTogglePlatform(platform.value)}
            sx={itemSx(isSelected, disabled)}
          >
            <Avatar
              src={platform.icon}
              alt={platform.value}
              variant="square"
              sx={{
                width: 24,
                height: 24,
                bgcolor: "transparent",
                ".MuiAvatar-img": {
                  objectFit: "contain",
                  filter: showFullColor
                    ? "none"
                    : "grayscale(1) saturate(0) contrast(1.05)",
                  transition: "filter 0.2s ease, opacity 0.2s ease",
                  opacity: showFullColor ? 1 : disabled ? 0.6 : 0.75,
                },
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontSize: 11,
                textAlign: "center",
                color: disabled ? "text.disabled" : "text.secondary",
              }}
            >
              {platform.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PlatformSelector;
